/// <amd-module name="Feed/Legacy/Utils/RestApi" />
import { IVssPageContext } from "VSS/Platform/Context";
import { combineUrlPaths, Uri } from "VSS/Platform/Util/Url";

import { PackagingServiceInstanceId } from "Feed/Common/Constants/Constants";
import { getServiceRootPath } from "Helpers/UrlHelper";

import { getCurrentSelectedProjectId, getCurrentSelectedProjectName } from "../Helpers/ProjectHelper";

export interface IRestApiRoutes {
    locationId: string;
    resource: string;
    routeTemplate: string;
}

const ApisRelativePath: string = "_apis";

export function generatePackagingServiceRestApiUri(
    pageContext: IVssPageContext,
    path: string,
    ignoreApisRelativePath: boolean = false,
    includeProject: boolean = false
): string {
    const packagingServiceRootPath = getServiceRootPath(pageContext, PackagingServiceInstanceId);
    var project = null;

    if (includeProject) {
        const projectName = getCurrentSelectedProjectName(pageContext);
        // Project names can contain spaces, which mean they need to be encoded before they are returned to be
        // used in any client. However, mvn currently doesn't support having encoded urls for `mvn deploy` command.
        // This is a known bug in maven and is being tracked here: https://issues.apache.org/jira/browse/MDEPLOY-261
        // To prevent older mvn clients from breaking, we check here if the projectName needs to be encoded (in case
        // it has a space or any special character), and if so we return the project guid instead for all clients.
        project = encodeURI(projectName) === projectName ? projectName : getCurrentSelectedProjectId(pageContext);
    }

    return generateServiceRestApiUri(packagingServiceRootPath, path, ignoreApisRelativePath, project).absoluteUri;
}

export function generateServiceRestApiUri(
    serviceRootPath: string,
    path: string,
    ignoreApisRelativePath: boolean = false,
    project: string = null
): Uri {
    const url = combineUrlPaths(serviceRootPath, project, ignoreApisRelativePath ? "" : ApisRelativePath, path);
    return new Uri(decodeURIComponent(url));
}
